import type { TFunction } from 'i18next';
import { number } from 'yup';

import yup from '../../../shared/validation';

export function getProgramItemFormValidation(t: TFunction) {
  return yup.object({
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameRequired')),
    programSets: yup.array().of(
      yup.object().shape({
        exercise: yup.object().required(t('formikValidation.exerciseRequired')),
        programSetItems: yup.array().of(
          yup.object().shape({
            sets: number()
              .min(1, t('formikValidation.setsMinValue'))
              .required(t('formikValidation.setsCountRequired')),
            programSetItemOptions: yup.array().of(
              yup.object().shape({
                value: yup
                  .number()
                  .nullable()
                  // .required(t('formikValidation.valueRequired'))
                  .min(0, t('formikValidation.minValue').replace('{0}', '0')),
                value2: yup
                  .number()
                  .nullable()
                  .min(0, t('formikValidation.minValue').replace('{0}', '0')),
              }),
            ),
          }),
        ),
      }),
    ),
  });
}
